import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../Logo';
import teamsArray from '../../scripts/teams.js';
import './styles.less';

const LogoLink = (props) => {
    return (
        <a href={props.url}>
            <div data-aspect-ratio="1:1">
                <Logo logoSet="team-cap-on-light" id={props.teamId} />
            </div>
        </a>
    );
};

LogoLink.propTypes = {
    url: PropTypes.string.isRequired,
    teamId: PropTypes.oneOf(teamsArray.teams).isRequired
};

LogoLink.defaultProps = {
    url: undefined,
    teamId: undefined
};

export default LogoLink;
